import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetLoginUrlForReservationAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {GetLoginUrlWithQueryParamsService} deps.service
   */
  constructor({config, getLoginUrlWithQueryParamsService}) {
    super()
    this._config = config
    this._getLoginUrlWithQueryParamsService = getLoginUrlWithQueryParamsService
  }

  /**
   * @param {Object} params
   * @param {Object} data.search
   */

  @inlineError
  async execute() {
    const {RESERVATION_C2B_USER_FORM_PATH_PATTERN} = this._config.get('page')

    return this._getLoginUrlWithQueryParamsService
      .execute({url: RESERVATION_C2B_USER_FORM_PATH_PATTERN})
      .then(loginUrlVO => {
        const {url: loginUrl} = loginUrlVO.toJSON() || {}

        return {
          url: loginUrl && decodeURIComponent(loginUrl)
        }
      })
  }
}
